import { isEmpty } from 'lodash';
import { ORIENTATION_TYPE_OPTION_IDS } from 'commons/constants';

export const getBundleProductsWithOrientation = ({
  bundleProducts,
  parentOptions,
}) => {
  let modularParentOrientationOptions = {};
  let updatedBundleProducts =
    bundleProducts && bundleProducts.length ? [...bundleProducts] : [];
  const orientationOptionTypeIds = {};
  parentOptions.forEach(parentOption => {
    if (ORIENTATION_TYPE_OPTION_IDS.includes(parentOption.id)) {
      orientationOptionTypeIds[`${parentOption.id}`] = parentOption;
    }
  });
  modularParentOrientationOptions = { ...orientationOptionTypeIds };
  if (!isEmpty(modularParentOrientationOptions)) {
    const bundleProductsTemp = [];
    bundleProducts.forEach(prod => {
      if (prod.options) {
        // check if orientationoptions are present in the product.
        const orientationOpt = prod.options.find(
          x => modularParentOrientationOptions[`${x.id}`]
        );
        const orientationProps = {};
        // find the left and right if present and add duplicate product for each
        if (orientationOpt) {
          orientationProps.option_id = orientationOpt.id;
          // go through the option_values list and find the different orientation options and add to bundleProds
          // wrangle data and store in all combinations needed .
          orientationOpt.values[0].option_values.forEach(item => {
            orientationProps.currentSelection = {
              id: item.id,
              value: item.value,
              sku: item.sku,
            };
            orientationProps.option = { ...item };
            bundleProductsTemp.push({
              ...prod,
              orientation: { ...orientationProps },
            });
          });
        } else {
          bundleProductsTemp.push({ ...prod, orientation: {} });
        }
      } else {
        bundleProductsTemp.push({ ...prod, orientation: {} });
      }
    });

    updatedBundleProducts = [...bundleProductsTemp];
  }

  return {
    modularParentOrientationOptionsVal: modularParentOrientationOptions,
    bundleProductsVal: updatedBundleProducts,
  };
};
